/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import {useRef, useCallback, useEffect} from 'react';

const useTabTracking = (onTabClose) => {
  const windowRef = useRef(null);
  const trackingIntervalRef = useRef(null);

  const stopTracking = useCallback(() => {
    if (trackingIntervalRef.current) {
      clearInterval(trackingIntervalRef.current);
      trackingIntervalRef.current = null;
    }
  }, []);

  const startTracking = useCallback(() => {
    trackingIntervalRef.current = setInterval(() => {
      if (windowRef.current?.closed) {
        stopTracking();
        onTabClose();
      }
    }, 1000);
  }, [onTabClose, stopTracking]);

  const openInNewTab = useCallback(
    (url) => {
      windowRef.current = window.open(url, '_blank');
      startTracking();
    },
    [startTracking]
  );

  useEffect(
    () => () => {
      stopTracking();
      if (windowRef.current && !windowRef.current.closed) {
        windowRef.current.close();
      }
    },
    [stopTracking]
  );

  return {openInNewTab, stopTracking, windowRef, trackingIntervalRef};
};

export default useTabTracking;
